(function($) {
  $.widget('ui.axCarousel', {
    slideWidth: 0,
    slideMargin: 0,
    slidePadding: 0,
    animationDone: true,
    options: {
      startTab: '',               // selector or 0-based index
      axDataLocation: false,      // dataLocation for axTable, might be function if it's needed to update every time
			axDataProvider: false,
      animationTime: 500,
      slideScroll: 3,
      onFetch: function(e, fetched){}, // handler on fetch
      axTableOptions: {},
      tabs: {}
    },

    /**
     * Constructor
     * @private
     */
    _create: function() {
      var self = this;
    },

    /**
     * Initialize widget options on each start() call
     * @param args widget options to be set
     * @private
     */
    _init: function(args) {
      var self = this;

      if (typeof args != "undefined") {
        for (var item in self.options) {
          if (typeof args[item] != "undefined") {
            self.options[item] = args[item];
          }
        }
      }

      var current_tab = self._getCurrentTab();
      if (current_tab.find('.slide').length != 0) {
        self.slideWidth = current_tab.find('.slide').width();
        self.slideMargin = parseInt(current_tab.find('.slide').css('margin-right').replace('px', ''));
        self.slidePadding = parseInt(current_tab.find('.slide').css('padding-right').replace('px', '')) * 2;

        current_tab.find('.slides').css('width', current_tab.find('.slide').length * self._getTotalWidth());
      }

      var htab = current_tab.find('.axCarousel .header-tab');
      htab.click(function() {
        var item = $(this);
        htab.filter('.selected').removeClass('selected');
        item.addClass('selected');
				self._fetchData(item);
      });

      /** load some tab */
      var htab_ = null;
      if(!isNaN(parseFloat(self.options.startTab)) && isFinite(self.options.startTab)){
        /** use index */
        htab_ = htab.eq( self.options.startTab );
      } else if( self.options.startTab ){
        /** use selector */
        var htab_filtered = htab.filter( self.options.startTab );
        if( htab_filtered.length ){
          htab_ = htab_filtered.first();
        }
      }
      if(! htab_ ){
        /** use first not empty tab or first if all are empty */
        htab_ = htab.first();
        htab.each( function( i, el ){
          var $el = $( el );
          if( $el.data('num-items') > 0 ){
            htab_ = $el;
            return false;
          }
        });
      }
      htab_.click();
    },

    forceArrowReinit: function() {
      /*
      var $currentTab = this._getCurrentTab();
      var $selectedTab = $currentTab.find('.axCarousel .header-tab.selected');
      $currentTab
        .find('.arrow-tip')
        .animate({ 'left': $selectedTab.position().left + ($selectedTab.outerWidth(true) / 2) - 10 + "px" }, 200, function() {});
      */
    },

    _getCurrentTab: function() {
      return $(".ui-tabs-panel:visible");
    },

    _getTotalWidth: function() {
      return self.slideWidth + self.slideMargin + self.slidePadding;
    },

    _setAnimationDone: function() {
      self.animationDone = true;
    },

    _move: function(invert) {
      var self = this;
      var current_tab = self._getCurrentTab();
      var current_offset = current_tab.find(".slides").position().left;
      var delta = self._getTotalWidth() * self.options.slideScroll;
      var current_showing = (current_offset - current_tab.find(".slider").width()) * -1;

      if (invert != 'undefined' && invert == true) { delta *= -1; } // invert delta

      if (self.animationDone && (current_showing + (self._getTotalWidth() * self.options.slideScroll)) < current_tab.find(".slides").width()){
        self.animationDone = false;
        current_tab.find(".slides").animate(
          { left: current_offset + delta },
          self.options.animationTime,
          self._setAnimationDone
        );
      }
    },

    _moveLeft: function() {
      this._move(true);
    },

    _moveRight: function() {
      this._move(false);
    },

    _fetchData: function(item) {
      var self = this;
      var current_tab = self._getCurrentTab(), list = current_tab.find(".items-list");

      var axTable = list.data('ax-axTable');
      if (axTable) {
        axTable.destroy();
      }
      list.empty();

      // options is a link to self.options.axTableOptions object
      var options = self.options.axTableOptions;
      if (self.options.axDataLocation) {
				options.views.axTableList.dataLocation = typeof (self.options.axDataLocation) === 'function'
						? self.options.axDataLocation()
						: self.options.axDataLocation;
			}
      else {
      	options.views.axTableList.dataProvider = self.options.axDataProvider;
			}

      if (typeof self.options.onFetch === 'function') {
        list.one('datafetched.axTable', self.options.onFetch);
      }

      // check for custom tab options
      $.each(self.options.tabs, function(selector, opts) {
        var tab = $(selector);
        if (tab.length && item.is(tab)) {
          // link to new object from deep merge of options
          options = $.extend(true, {}, options, opts);
          return false;
        }
      });

      list.axTable(options);
    },

    getSelectedItem: function() {
      return this._getCurrentTab().find('.axCarousel .header-tab.selected');
    },

    getSelectedIndex: function() {
      return this.getSelectedItem().index();
    },

    updateCurrentTab: function() {
      var item = this.getSelectedItem();
      this._fetchData(item);
    }

  });

  $.extend($.ui.axCarousel, {
    version: "1.0.0"
  });
})(jQuery);
